import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './JokesTicker.css';

function JokesTicker() {
  const [jokes, setJokes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchJokes();
  }, []);

  const fetchJokes = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/jokes/feed');
      if (response.data && response.data.jokes) {
        setJokes(response.data.jokes);
        setError(null);
      }
    } catch (err) {
      console.error('Failed to fetch jokes:', err);
      setError('Failed to load jokes');
      // Set fallback jokes
      setJokes([
        "Why don't scientists trust atoms? Because they make up everything!",
        "Welcome to WTF Wear - Where humor meets fashion!",
        "I told my wife she was drawing her eyebrows too high. She looked surprised."
      ]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="jokes-ticker">
        <div className="ticker-content">
          <span className="ticker-item">Loading jokes...</span>
        </div>
      </div>
    );
  }

  // Create a long string of all jokes separated by bullets
  const tickerContent = jokes.join(' • ');

  return (
    <div className="jokes-ticker">
      <div className="ticker-wrapper">
        <div className="ticker-content">
          <span className="ticker-item">{tickerContent}</span>
          <span className="ticker-item">{tickerContent}</span>
        </div>
      </div>
    </div>
  );
}

export default JokesTicker;
